// src/services/adminPayments.js
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { fetchAllJobs } from "./adminJobs";

// Fetch all payments, newest first.
export async function fetchAllPayments() {
  const q = query(collection(db, "payments"), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
}

// Totals for the Payments dashboard.
// - collected: sum of payments.platformFee where status === "paid"
// - refunded:  sum of jobs.platformFee where refundStatus === "refunded"
// - profit:    collected - refunded
export async function fetchPaymentsSummary() {
  const [payments, jobs] = await Promise.all([
    fetchAllPayments(),
    fetchAllJobs(),
  ]);

  const collected = payments
    .filter((p) => p.status === "paid")
    .reduce((sum, p) => sum + (Number(p.platformFee) || 0), 0);

  const refunded = jobs
    .filter((j) => j.refundStatus === "refunded")
    .reduce((sum, j) => sum + (Number(j.platformFee) || 0), 0);

  return {
    collected,
    refunded,
    profit: collected - refunded,
    payments,
  };
}